import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import * as api from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';

const ModalNegativacao = ({ cpf, show, onClose, onSave }) => {
  const [historico, setHistorico] = useState([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [exibirForm, setExibirForm] = useState(false);
  const [motivo, setMotivo] = useState('');
  const [salvando, setSalvando] = useState(false);

  const carregarHistorico = async () => {
    setLoadingHistorico(true);
    try {
      const resp = await api.consultaCPFNegativacaoHistorico(cpf);
      setHistorico(Array.isArray(resp) ? resp : []);
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar histórico';
      toast.error(msg);
    } finally {
      setLoadingHistorico(false);
    }
  };

  useEffect(() => {
    if (show && cpf) {
      carregarHistorico();
    }
  }, [show, cpf]); // eslint-disable-line react-hooks/exhaustive-deps

  // Fix: SQL retorna 'INCLUSÃO'/'EXCLUSÃO' (não 'I'/'E') — comparar com texto formatado
  const getProximoTipo = () => {
    if (historico.length === 0) return 'I';
    const ultimo = historico[0];
    return (ultimo.tipo === 'INCLUSÃO' || ultimo.tipo === 'INCLUSAO') ? 'E' : 'I';
  };

  const getLabelProximoTipo = () => {
    const tipo = getProximoTipo();
    return tipo === 'I' ? 'Incluir Negativação' : 'Excluir Negativação';
  };

  // Fix #5: Permissão 388 verificada aqui (não ao abrir modal) — fiel ao Delphi BtnIncluirClick
  const handleIniciarInclusao = () => {
    const temPermissao = AuthStorage.temCaracteristicas([caracteristicas.NegativacaoInternaCliente]);
    if (!temPermissao) {
      toast.error('Usuário sem característica NEGATIVACAO INTERNA DE CLIENTE.');
      return;
    }
    setMotivo('');
    setExibirForm(true);
  };

  const handleCancelar = () => {
    setExibirForm(false);
    setMotivo('');
  };

  const handleGravar = async () => {
    if (!motivo || !motivo.trim()) {
      toast.error('Motivo deve ser informado.');
      return;
    }
    const confirmar = window.confirm('Deseja salvar?');
    if (!confirmar) return;

    setSalvando(true);
    try {
      await api.consultaCPFNegativacaoIncluir({ cpf, motivo: motivo.trim() });
      toast.success('Negativação registrada com sucesso.');
      setExibirForm(false);
      setMotivo('');
      await carregarHistorico();
      onSave();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao salvar negativação';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const formatarData = (data) => {
    if (!data) return '—';
    const m = moment(data);
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : '—';
  };

  // Fix: SQL já retorna texto formatado ('INCLUSÃO'/'EXCLUSÃO') — usar direto
  const formatarTipo = (tipo) => tipo;

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Negativação do CPF</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!exibirForm ? (
          <>
            {loadingHistorico ? (
              <p>Carregando histórico...</p>
            ) : (
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Data</th>
                    <th>Tipo</th>
                    <th>Usuário</th>
                    <th>Motivo</th>
                  </tr>
                </thead>
                <tbody>
                  {historico.length === 0 ? (
                    <tr>
                      <td colSpan={5} className="text-center text-muted">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  ) : (
                    historico.map((item) => (
                      <tr key={item.codigo}>
                        <td>{item.codigo}</td>
                        <td>{formatarData(item.data)}</td>
                        <td>{formatarTipo(item.tipo)}</td>
                        <td>{item.nome_usuario}</td>
                        <td>{item.motivo}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            )}
          </>
        ) : (
          <Form>
            <Form.Group>
              <Form.Label>
                <strong>Tipo:</strong>{' '}
                {getProximoTipo() === 'I' ? 'INCLUSÃO' : 'EXCLUSÃO'}
              </Form.Label>
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Motivo <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                placeholder="Informe o motivo..."
              />
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        {!exibirForm ? (
          <>
            <Button variant="primary" onClick={handleIniciarInclusao}>
              {getLabelProximoTipo()}
            </Button>
            <Button variant="secondary" onClick={onClose}>
              Sair
            </Button>
          </>
        ) : (
          <>
            <Button variant="success" onClick={handleGravar} disabled={salvando}>
              {salvando ? 'Salvando...' : 'Gravar'}
            </Button>
            <Button variant="outline-secondary" onClick={handleCancelar} disabled={salvando}>
              Cancelar
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalNegativacao;
